import { ArrowRight } from "lucide-react";

const Hero = () =>
<section
  id="home"
  className="relative min-h-screen flex items-center justify-center overflow-hidden"
  aria-label="Hero section">
  
    <picture>
      <source media="(max-width: 900px)" srcSet="/hero-bg-mobile.webp" />
      <img
        src="/hero-bg.webp"
        alt="Industrial steel pipes and tubes background"
        className="absolute inset-0 w-full h-full object-cover"
        width={1600}
        height={900}
        fetchPriority="high"
      />
    </picture>
  
    <div className="absolute inset-0 bg-primary/75" />

    <div className="relative z-10 container mx-auto px-4 text-center">
      <p className="text-accent font-display text-sm md:text-base uppercase tracking-[0.3em] mb-4">SINCE 1990</p>

      <h1 className="font-display text-4xl sm:text-5xl md:text-7xl font-bold text-primary-foreground leading-tight mb-6">
      
        Taher Steel Tube Co.
        <br />
        <span className="text-accent">MS &amp; GI Pipe Supplier in Coimbatore</span>

      </h1>

      <p className="font-body text-primary-foreground/80 text-lg md:text-xl max-w-2xl mx-auto mb-10">
      
        MS & GI pipes, ERW & seamless steel tubes, valves, fittings, flanges
        & fire safety systems — authorized Jindal, Tata & APL Apollo dealer
        in Coimbatore with pan-India delivery.
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
      
        <a
        href="#products"
        className="bg-accent text-accent-foreground font-display font-semibold text-base px-8 py-4 rounded hover:brightness-110 transition flex items-center gap-2">
        
          View Products
          <ArrowRight className="w-5 h-5" />
        </a>
        <a
        href="#quote"
        className="border-2 border-primary-foreground/30 text-primary-foreground font-display font-semibold text-base px-8 py-4 rounded hover:bg-primary-foreground/10 transition">
        
          Get a Quote
        </a>
      </div>
    </div>

    <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background to-transparent" />
  </section>;


export default Hero;